import { TReduxActions } from '../../actions';
import { EEmptyListingSuggestionsActionType } from '../../actions/emptyListingSuggestions';
import { ELoadListingActionTypes } from '../../actions/listingOffers';
import { EAddToFavoritesActionTypes } from '../../actions/newFavorites/addToFavorite';
import { ERemoveFromFavoritesActionTypes } from '../../actions/newFavorites/removeFromFavorite';
import { IEmptyListingSuggestionsState } from '../../types/emptyListingSuggestions';
import { EFetchStatus } from '../../types/listingOffers';

export const defaultState: IEmptyListingSuggestionsState = {
  status: null,
  offers: [],
};

/**
 * Рекомендации «Вам могут подойти» на пустой выдаче десктопа.
 * Источник — ручка search-engine /v1/infinite-search-for-mobile-site/.
 * Не путать с offersSuggestions (перетоки, mobile, get-suggestions-for-user).
 */
export function emptyListingSuggestionsReducer(
  state: IEmptyListingSuggestionsState = defaultState,
  action: TReduxActions,
): IEmptyListingSuggestionsState {
  switch (action.type) {
    case EEmptyListingSuggestionsActionType.Request:
      return { status: EFetchStatus.LOADING, offers: [] };
    case EEmptyListingSuggestionsActionType.Success:
      return { status: EFetchStatus.SUCCESS, offers: action.payload };
    case EEmptyListingSuggestionsActionType.Failure:
      return { status: EFetchStatus.FAILURE, offers: [] };
    case ELoadListingActionTypes.Request:
      // Стартовал новый поиск листинга — старые рекомендации сразу неактуальны.
      // Без сброса при переходе «пустая выдача → новая пустая» remount empty-ветки
      // на один кадр показал бы старые карточки до скелетонов.
      return action.payload.reset ? defaultState : state;
    case ELoadListingActionTypes.Success:
      // Пришла непустая основная выдача — рекомендации пустого листинга неактуальны.
      return defaultState;
    case ERemoveFromFavoritesActionTypes.Success:
    case EAddToFavoritesActionTypes.Success: {
      const { offerId, isFavorite } = action.payload;

      const offerToChangeIdx = state.offers.findIndex(offer => offer.id === offerId);

      if (offerToChangeIdx === -1) {
        return state;
      }

      const offers = state.offers.slice();
      offers[offerToChangeIdx] = { ...offers[offerToChangeIdx], isFavorite };

      return { ...state, offers };
    }
    default:
      return state;
  }
}
